import { useState } from 'react';
import Script from 'next/script';

export default function Developers({ locals }) {
    const [mounted, setMounted] = useState(false);

    const unsafeJs = `window.$docsify = {
        name: 'Portal API',
        basePath: '/developers',
        loadSidebar: true,
        loadNavbar: true,
        subMaxLevel: 3,
        logo: 'images/bio-dev.svg',
        plugins: [
            function (hook, vm) {
                hook.beforeEach(function (content) {
                    content = content.replace(/{SITE_HOST}/g, '${locals.siteUrl}');
                    content = content.replace(/{PAGE_SIZE}/g, '${locals.pageSize}');

                    return content;
                });
            },
        ],
    };`;

    return (
        <>
            <Script id="s1" strategy="afterInteractive" dangerouslySetInnerHTML={{ __html: unsafeJs }} />

            <Script
                id="s2"
                async={false}
                strategy="afterInteractive"
                src="//cdn.jsdelivr.net/npm/docsify@^5.0.0-rc"
                crossOrigin="anonymous"
                referrerPolicy="no-referrer"
                onLoad={() => setMounted(true)}
            />

            <Script
                id="s3"
                async={false}
                strategy="afterInteractive"
                src="//cdn.jsdelivr.net/npm/docsify-copy-code@2.1.1/dist/docsify-copy-code.min.js"
                integrity="sha256-8RM7T/q4FqeRqHqvRITDUFPFrMuFyE+PpeaFpdLM0Fw="
                crossOrigin="anonymous"
                referrerPolicy="no-referrer"
            />

            <Script
                id="s4"
                async={false}
                strategy="afterInteractive"
                src="//cdn.jsdelivr.net/npm/docsify-tabs@1.6.3/dist/docsify-tabs.min.js"
                integrity="sha256-zxjWF8K1PytAeqtsfF1d8OJot0wCi32wOUchda16XJI="
                crossOrigin="anonymous"
                referrerPolicy="no-referrer"
            />

            {mounted && (
                <Script
                    id="s5"
                    async={false}
                    src="//cdnjs.cloudflare.com/ajax/libs/prism/9000.0.1/prism.min.js"
                    strategy="afterInteractive"
                    integrity="sha512-UOoJElONeUNzQbbKQbjldDf9MwOHqxNz49NNJJ1d90yp+X9edsHyJoAs6O4K19CZGaIdjI5ohK+O2y5lBTW6uQ=="
                    crossOrigin="anonymous"
                    referrerPolicy="no-referrer"
                />
            )}
        </>
    );
}
